import React, { useState, FC, useEffect } from 'react';
import "./index.less";

type IFields = {
    [key: string]: any
}
type IFieldList = {
    [key: string]: IYhMultiSelectItem[]
}

//每个系列的 item
export interface IYhMultiSelectItem {
    title: string,
    value: string,
    active: boolean,
    [key: string]: any
}

//每个系列的配置信息
export interface IYhMultiSelectSeries {
    field: string,
    title: string,
    typeList: IYhMultiSelectItem[]
}

export type IYhMultiSelectProps = {
    valueType?: "title" | "value"
    isCatch?: boolean,
    seriesDataSaurce: IYhMultiSelectSeries[],
    filterFields: IFields,
    setFilterFields: (value: React.SetStateAction<IFields>) => void,
    onChange: (obj: IFields) => void,
    isShowOne?: boolean,
    handleShowOne?: () => void
}

export const YhMultiSelect: FC<IYhMultiSelectProps> = ({
    valueType = "title",
    seriesDataSaurce,
    filterFields,
    isShowOne = true,
    handleShowOne,
    setFilterFields,
    onChange
}) => {
    const [showOne, setShowOne] = useState<boolean>(isShowOne);
    /**
     * 1.回显选中的缓存， 每次加载组件
     *     判断选中的是否有缓存?
     *                        找到对应的行，并设置选中的active
     *                       ：
     *                        返回数据源 
     */

    const [dataSaurce, setDataSaurce] = useState<IYhMultiSelectSeries[]>([]);

    useEffect(() => {
        setDataSaurce(() => {
            let origin = [...seriesDataSaurce];
            let fieldArr = Object.keys(filterFields);

            if (fieldArr.length) {
                fieldArr.forEach(item => {
                    let findIndex = origin.findIndex(i => i.field === item);  //字段对应的item下标
                    findIndex >= 0 && origin.splice(findIndex, 1, {
                        ...origin[findIndex],
                        typeList: origin[findIndex].typeList?.map(j => ({
                            ...j,
                            active: j[valueType] === filterFields[item]
                        }))
                    });
                })
            };
            return origin;
        })
    }, [seriesDataSaurce]);

    //缓存对应字段的item， 方便查询
    const [fieldTyoelist] = useState(() => {
        let obj: IFieldList = {}
        seriesDataSaurce.forEach(item => {
            obj[item.field] = item.typeList
        })
        return obj;
    })
    /**
     * 点击每个系列选项事件
     * @param option 每个系列的配置信息
     * @param optionIndex 对应系列的下标
     * @param node 系类的每一项
     */
    const onSeriesChange = (option: IYhMultiSelectSeries, optionIndex: number, node: IYhMultiSelectItem) => {
        let { field, title, typeList } = option;

        setFilterFields(origin => {
            let newObj = { ...origin };
            if (node.title === "全部") {
                delete newObj[field];
            } else {
                newObj[field] = valueType === "title" ? node.title : node.value;
            }
            onChange?.(newObj);
            return newObj;
        });

        let changeActiveList = typeList.map(item => ({
            ...item,
            active: item.value === node.value ? true : false
        }));

        setDataSaurce(origin => {
            origin.splice(optionIndex, 1, { field, title, typeList: changeActiveList });
            return origin;
        })
    }

    /**
     * 点击已选的关闭按钮
     * @param seriesField 对应系列field的val
     */
    const onCloseItem = (seriesField: string) => {
        setFilterFields(origin => {
            let newObj = { ...origin };
            delete newObj[seriesField];
            onChange?.(newObj);
            return newObj;
        });

        //关闭某个系列，查到当前系列并且把全部设置为全部展示
        setDataSaurce(origin => {
            let findIndex = origin.findIndex(i => i.field === seriesField);
            if (findIndex >= 0) {
                let { field, title, typeList } = origin[findIndex];
                let changeActiveList = typeList.map(item => ({
                    ...item,
                    active: item.title === "全部" ? true : false
                }))
                origin.splice(findIndex, 1, { field, title, typeList: changeActiveList });
            }
            return origin;
        })
    }

    return (
        <div className="filter-wrap">
            {dataSaurce && dataSaurce.map((option, index) => (
                <div className="series" key={option.field} hidden={showOne ? index !== 0 : false}>
                    <div className="series-title">{option.title}：</div>
                    <ul className="series-list">
                        {option.typeList && option.typeList.map(node => (
                            <li
                                className={`series-item ${node.active ? "series-active" : ""}`}
                                key={node.value}
                                onClick={() => onSeriesChange(option, index, node)}
                            >{node.title}</li>
                        ))}
                    </ul>
                </div>
            ))}

            <div className="choose-type">
                <div className="choose-title">已选条件</div>
                {Object.keys(filterFields).length ?
                    <ul className="filter-list">
                        {Object.keys(filterFields).map(item => (
                            <li className="filter-item" key={item}>
                                <span>{valueType === "title" ?
                                    filterFields[item] :
                                    fieldTyoelist[item]?.find(j => j.value === filterFields[item])?.title ?? ""}
                                </span>
                                <span
                                    className="delete-type"
                                    onClick={() => onCloseItem(item)}
                                >x</span>
                            </li>
                        ))}
                        <li className="filter-item" >
                            <span onClick={() => {
                                setFilterFields({});
                                setDataSaurce(() => [...seriesDataSaurce]);
                                onChange?.({})
                            }}>清除已选条件</span>
                        </li>
                    </ul> :
                    <span className="no-series">暂时没有选择过滤条件</span>
                }
                <div className="choose-title hiddenBtn" onClick={() => {
                    handleShowOne?.();
                    setShowOne(origin => !origin);
                }}>{showOne ? "更多.." : "隐藏"}</div>
            </div>
        </div>
    );
}

